import { onMounted, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';

// Rede de segurança da Central de avisos: o cable avisa na hora (actionCable.js
// → opsNotices/fetch), mas cable caído não pode congelar o badge — rebusca a
// cada 45 s. Montado UMA vez, na sidebar (que vive em todas as telas).
// Aba oculta não rebusca (ninguém vê o badge e são N abas por atendente
// fazendo request à toa); ao voltar a ficar visível, rebusca na hora.
export const OPS_NOTICES_REFETCH_MS = 45_000;

const isVisible = () => document.visibilityState === 'visible';

export function useOpsNoticesSync() {
  const store = useStore();
  let timer = null;

  const refetch = () => store.dispatch('opsNotices/fetch');

  const tick = () => {
    if (isVisible()) refetch();
  };

  const onVisibilityChange = () => {
    if (isVisible()) refetch();
  };

  onMounted(() => {
    refetch();
    timer = setInterval(tick, OPS_NOTICES_REFETCH_MS);
    document.addEventListener('visibilitychange', onVisibilityChange);
  });

  onBeforeUnmount(() => {
    clearInterval(timer);
    document.removeEventListener('visibilitychange', onVisibilityChange);
  });
}
